import { getIn, useFormikContext } from 'formik';
import React from 'react';
import { Label } from 'reactstrap';



// Two decimals for money; leaves empty or non-numeric values as they are
const toCurrency = (v) => v === '' || v == null || isNaN(parseFloat(v)) ? v : parseFloat(v).toFixed(2);

const CompareFormValue = (props) => {
    const { values } = useFormikContext();
    const { compare,originalContent,children,render, renderOriginal, id, rows, style,prefix,type,prefferedLabelColor, ...rest } = props;
    const orig = originalContent ? originalContent : getIn(values, 'original.' + id);
    const value = children ? children : id ? getIn(values, id) : null;
    const original = orig ? orig : compare && value ? "No Value" : null;
    const originals = getIn(values, 'original');
 
    const val = (prefix ? prefix : '') + (render ? render({ ...values, value }) : value?value:'');

    return original && original !== value? <React.Fragment>
        <Label {...rest} style={{ color: 'red', fontFamily: 'RobotoRegular', fontSize: '0.9rem',width:'100%', ...style }}>
            <del>{prefix}{render ? render({ ...originals, value: original }) : type === 'currency' ? toCurrency(original) : original}</del>
        </Label><Label {...rest} style={{ color:!prefferedLabelColor? '#3E4D57':prefferedLabelColor,  fontFamily: 'RobotoRegular', fontSize: '0.9rem', width: '100%', ...style }}>
            {type === 'email' ? <a href={'mailTo://' + val} >{val}</a> :
                type === 'phone' ? <a href={'tel://' + val} >{val}</a> :
                type === 'currency' ? toCurrency(val) : val}
    </Label>

    </React.Fragment> : <Label {...rest} style={{ color:!prefferedLabelColor? '#3E4D57':prefferedLabelColor, fontFamily: 'RobotoRegular', fontSize: '0.9rem', width: '100%',...style }}>
            {type === 'email' ? <a href={'mailTo://' + val} >{val}</a> :
                type === 'phone' ? <a href={'tel://' + val} >{val}</a> :
                type === 'currency' ? toCurrency(val) : val}
  </Label>
}

export default CompareFormValue;